import { createApi } from '@reduxjs/toolkit/query/react';
import { axiosBaseQuery } from './base.service';

export const JourneyMapApi = createApi({
  reducerPath: 'JourneyMapApi',
  baseQuery: axiosBaseQuery(),
  endpoints: () => ({}),
});
